<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="4">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="1">
        <ul>
          <li>
            <span class="text-red">Total Blocked</span>
            <span>{{ pagination?.total }}</span>
          </li>
          <!-- <li>
            <v-btn small outlined elevation="0" @click="downloadExcel">
              <v-icon>mdi-file-download-outline</v-icon>
            </v-btn>
          </li> -->
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="accounts" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.fname="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.id}`">
                  {{ item?.fname + " " + item.lname }} {{ "(" + item.id + ")" }}
                </router-link>
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.user_doc_status="{ item }">
                <div class="d-flex align-items-center">
                  <div>
                    <v-icon small :class="verifyIcon(item.user_doc_status)"></v-icon>
                    {{ item.user_doc_status }}
                  </div>
                </div>
              </template>
              <template v-slot:item.action="{ item }">
                <v-dialog v-model="unblockModal" max-width="400" class="rounded-0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    color="#039de9"
                    small tile elevation="0" class="ma-0 text-capitalize btn-account blocked-user-btn" 
                      v-bind="attrs" v-on="on">
                      Unblock & Make Registered User
                    </v-btn>
                  </template>
                  <v-card rounded="0" width="400" class="auth-modal-card"
                    :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
                    <v-card-title class="px-0 pt-0"> Unblock? </v-card-title>
                    <v-card-text class="px-0">Do you want to unblock & make registered user?</v-card-text>
                    <v-card-actions class="px-0 pb-0">
                      <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
                        @click="unBlockUser(item.id); unblockModal = false">
                        Unblock
                      </v-btn>
                      <v-btn class="elevation-0" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'" outlined
                        @click.prevent="unblockModal = false">
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.details="{ item }">
                <router-link :to="`/registered-user-details/${item.id}`">
                  <v-icon color="#039de9" small>mdi-eye-outline</v-icon>
                </router-link>
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { BLOCKEDUSER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      selectedDates: [],
      selectedDatesText: null,
      unblockModal: false,
      uploadModal: false,
      isCopied: false,
      copiedStates: {},
      searchManagerModal: false,
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      dialog: false,
      headers: [
        { text: "Registered At", align: "start", value: "created_at" },
        { text: "Name", value: "fname" },
        { text: "Email", value: "email" },
        { text: "Document", value: "user_doc_status" },
      ],
    };
  },

  computed: {
    ...mapState("blockedusers", ["accounts", "pagination",
      "isLoading"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("blockedusers", [
      BLOCKEDUSER__ACTIONS.BLOCKEDUSER,
      BLOCKEDUSER__ACTIONS.UNBLOCKUSER,
    ]),

    verifyIcon(status) {
      if (status.startsWith("V")) {
        return "mdi mdi-check text--green mr-1";
      } else if (status.startsWith("N")) {
        return "mdi mdi-window-close red--text mr-1";
      } else {
        return "mdi mdi-refresh mr-1 yellow--text";
      }
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    unBlockUser(userId) {
      const parameter = {
        id: userId,
      };
      this[BLOCKEDUSER__ACTIONS.UNBLOCKUSER](parameter);
    },


    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.users;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.id,
        NAME: item.fname + " "  + item.lname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        DOCUMENT: item.user_doc_status,
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "Blocked Accounts");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "blocked_accounts.xlsx");
    },

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[BLOCKEDUSER__ACTIONS.BLOCKEDUSER](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData()
    if (this.$canRoute('registered-user?tab=5') === 1) {
      this.headers.push({ text: "Actions", value: "action" });
      this.headers.push({ text: "Details", value: "details" });
    }
  },
};
</script>
